module.exports = __webpack_public_path__ + "img/IDEA.51038e32.png";